import { HttpParams } from '@angular/common/http';

export const QueryUtils = {
    convertToFilter(objeto: any): HttpParams {
        let params = new HttpParams();
        if (objeto && Object.keys(objeto).length > 0) {
            params = this.createKeys(objeto, params);
        }
        return params;
    },

    createKeys(objeto: any, params: HttpParams): HttpParams {
        for (const clave in objeto) {
            if (objeto[clave] != null && objeto[clave] != undefined) {
                params = params.append(clave, objeto[clave]);
            }
        }
        return params;
    },

    buildUrl(params: any): string {
        if (!params) return '';
        const queryParams = Object.keys(params)
            .map((key) => `${params[key]}`)
            .join('/');
        return queryParams ? `${queryParams}` : '';
    },

    setTotals(records: any[]) {
        if (!records) {
            return {
                startBalanceSum: 0,
                monthlyContribution: 0,
                endBalanceSum: 0,
                percentSum: 0,
                interestEarnedSum: 0,
                totalSum: 0
            };
        }
        return {
            startBalanceSum: this.calculateSum(records, 'startBalance'),
            monthlyContribution: this.calculateSum(records, 'monthlyContribution'),
            endBalanceSum: this.calculateSum(records, 'endBalance'),
            percentSum: this.calculateSum(records, 'percent'),
            interestEarnedSum: this.calculateSum(records, 'interestEarned'),
            totalSum: this.calculateSum(records, 'total')
        };
    },

    calculateSum(filteredRecords: any[], field: string): number {
        return filteredRecords.reduce((acc, record) => {
            const value = parseFloat(record[field]);
            return acc + (isNaN(value) ? 0 : value);
        }, 0);
    },

    applyFilter(records: any[], params: any): any[] {
        const filterKeys = Object.keys(params.params);
        let filteredRecords = records;

        filterKeys.forEach(key => {
            if (params.params[key]) {
                const searchTerm = params.params[key].toString().toLowerCase();
                filteredRecords = filteredRecords.filter(record =>
                    record[key] && record[key].toString().toLowerCase().includes(searchTerm)
                );
            }
        });
        return this.orderRecordsByParams(filteredRecords, params);
    },

    orderRecordsByParams(records: any[], params: any): any[] {
        return records;
    }
};
